import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { call, get } from '@swf/core/api/embedded';
import useFromEvent from '@swf/core/hooks/useFromEvent';
import { select } from '@swf/core/store';

export const useNativeLoader = (): void => {
  const hasClientSession = useSelector(select.session.hasClientSession);
  const fromEvent = useFromEvent();

  useEffect(() => {
    if (!hasClientSession) return;

    get(['app', 'ready'])
      ? call(['app', 'setLoading'], false)
      : fromEvent(document, 'starsready').subscribe(() => call(['app', 'setLoading'], false));
  }, [hasClientSession, fromEvent]);
};
